<template>
  <div style="background-color: #efeff4">
    <div class="top">
      <div class="top-one">
        <div style="display: flex">
          <div>
            <img
              v-if="details.name == '中国电信'"
              class="img"
              src="../assets/电信.jpg"
            />
            <img
              v-if="details.name == '中国联通'"
              class="img"
              src="../assets/联通.jpg"
            />
            <img
              v-if="details.name == '中国移动'"
              class="img"
              src="../assets/移动.jpg"
            />
            <img
              v-if="details.name == '三网通'"
              class="img"
              src="../assets/三网通.jpg"
            />
            <img
              v-if="details.name == '中国广电'"
              class="img"
              src="../assets/g.png"
            />
          </div>
          <div class="text">
            <div style="display: flex; align-items: center">
              <div class="line" style="font-weight: 700; font-size: 15px">
                设备号 :
                {{
                  details.virtualNumber
                    ? details.virtualNumber
                    : details.meCardNum
                }}
              </div>
              <div v-if="details.seriesModel.speedMembershipIds">
                <div
                  @click="speedRouter"
                  v-if="details.speedMemberEndTime"
                  style="font-size: 12px; margin-left: 5px; line-height: 17px"
                  class="active"
                >
                  VIP已加速
                </div>
                <div
                  v-else
                  @click="speedRouter"
                  style="
                    font-size: 12px;
                    color: #f5f5f5;
                    margin-left: 5px;
                    line-height: 17px;
                    color: red;
                  "
                >
                  续费极速会员
                </div>
              </div>
            </div>
            <!-- <div
                 @click="speedRouter"
              style="
                font-size: 12px;
                color: #f5f5f5;
                margin-left: 5px;
                line-height: 17px;
                color: red;
              "
            >
              暂未加速
            </div> -->
            <div class="linea">
              设备余额 : {{ details.balance }} 元
              <span
                style="color: red; font-size: 13px; margin-left: 5px"
                @click="banlance"
              >
                充值
              </span>
            </div>
            <div class="linea" v-if="details.falseOpMap">
              <span v-for="item in details.falseOpMap" :key="item.id">
                <van-tag
                  style="margin-right: 3px; margin-bottom: 10px"
                  :type="item.value == 0 ? 'primary' : 'danger'"
                >
                  {{ item.name.substring(2, 4)
                  }}{{
                    item.value == 0
                      ? "已实名"
                      : item.value == 1
                      ? "未实名"
                      : "未知"
                  }}
                </van-tag>
              </span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div v-if="details.virtualNumber" class="ref" @click="showe = true">
            <div style="margin-top: 5px">
              <van-icon name="exchange" />
            </div>
            <div style="margin-top: -3px; font-weight: 700">切换</div>
          </div>
          <div class="ref" style="margin-left: 5px" @click="refresh">
            <div style="margin-top: 5px">
              <van-icon name="replay" />
            </div>
            <div style="margin-top: -3px; font-weight: 700">刷新</div>
          </div>
        </div>
      </div>
    </div>
    <van-grid :column-num="4">
      <van-grid-item style="height: 50px">
        <div class="num">
          {{ details.sumFlowStr?details.sumFlowStr:Math.floor((details.surplusFlow / 1024) * 100) / 100+'G' }}
        </div>
        <div>剩余流量</div>
      </van-grid-item>
      <van-grid-item style="height: 50px">
        <div class="num">
          <div v-if="details.state == -1">未知</div>
          <div v-if="details.state == 0">正常</div>
          <div v-if="details.state == 1">单项停机</div>
          <div v-if="details.state == 2">停机</div>
          <div v-if="details.state == 3">预销号</div>
          <div v-if="details.state == 4">销号/拆机</div>
          <div v-if="details.state == 5">过户</div>
          <div v-if="details.state == 6">休眠</div>
          <div v-if="details.state == 7">待激活</div>
          <div v-if="details.state == 8">已停用</div>
          <div v-if="details.state == 9">库存</div>
          <div v-if="details.state == 10">已失效</div>
          <div v-if="details.state == 11">违章停机</div>
          <div v-if="details.state == 12">挂失</div>
          <div v-if="details.state == 13">用户报停</div>
          <div v-if="details.state == 14">不存在</div>
          <div v-if="details.state == 15">低速</div>
          <div v-if="details.state == 16">可测试</div>
        </div>
        <div>设备状态</div>
      </van-grid-item>
      <van-grid-item style="height: 50px">
        <div class="num">{{ details.days }}天</div>
        <div>剩余时间</div>
      </van-grid-item>
      <van-grid-item style="height: 50px">
        <div class="num">
          <span v-if="details.officialRealName == 0">已实名</span>
          <span v-if="details.officialRealName == 1">未实名</span>
          <span v-if="details.officialRealName == -1">未知</span>
        </div>
        <div>官方实名</div>
      </van-grid-item>
    </van-grid>
    <div class="middle">
      <van-tabs
        v-model="biaoshi"
        @click="onClick"
        title-active-color="#07c160"
        color="#07c160"
        animated
      >
        <van-tab
          v-for="items in cc"
          :key="items.id"
          :title="items.categoryName"
        >
          <div
            style="
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;
              padding: 5px;
            "
          >
            <div
              class="box"
              @click="router(item)"
              v-for="item in items.setMealModels"
              :key="item.id"
            >
              <div
                v-if="item.upRight"
                :id="item.id"
                class="tuijian"
                :style="{ background: item.upRightColor }"
              >
                {{ item.upRight }}
              </div>
              <div class="order">
                <!-- {{ item.name }} -->
                <span
                  style="
                    font-size: 20px;
                    line-height: 22px;
                    font-weight: 700;
                    margin-right: -3px;
                  "
                >
                  {{ item.couponEndPrice }}
                </span>
                元/
                <span v-if="item.validityType == 0" style="margin-left: -5px">
                  {{ item.validity }}天
                </span>
                <span v-if="item.validityType == 1" style="margin-left: -5px">
                  {{ item.validity }}个月
                </span>
                <span v-if="item.validityType == 2" style="margin-left: -5px">
                  {{ item.validity }}年
                </span>
              </div>
              <div class="hiddens">{{ item.lowerLeft }}</div>
              <div class="hidden" :style="{ color: item.lowerRightColor }">
                {{ item.lowerRight }}
              </div>
            </div>
            <div class="boxs"></div>
            <!-- <div class="boxs"></div> -->
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="bottom" :style="cc.length > 0 ? 'height:30vh' : 'height:70vh'">
      <div
        v-if="tel1.length > 0 || details.seriesModel.tel"
        style="color: #000; font-size: 16px"
      >
        服务热线:
        <a
          style="color: #07c160; text-decoration: underline"
          :href="
            details.seriesModel.tel ? 'tel:' + details.seriesModel.tel : tel
          "
        >
          {{ details.seriesModel.tel ? details.seriesModel.tel : tel1 }}
        </a>
      </div>
      <div
        v-if="zuo.length > 0"
        style="color: #a9a9a9; font-size: 16px; margin-top: 10px"
      >
        工作时间:{{ zuo }}
      </div>
      <div style="color: #000; margin-top: 10px">
        <span style="color: #07c160; font-size: 16px" @click="problem">
          常见问题
        </span>
        |
        <span style="color: #07c160; font-size: 16px" @click="order">
          充值记录
        </span>
        |
        <span style="color: #07c160; font-size: 16px" @click="kefu">
          联系客服
        </span>
      </div>
      <div
        style="
          font-size: 16px;
          color: #000;
          display: flex;
          justify-content: center;
        "
      >
        <div v-html="officialAccount"></div>
      </div>
    </div>
    <van-action-sheet
      style="
        background-image: linear-gradient(to left, #198aff, #79bbff);
        color: #ffffff;
      "
      :title="title"
      :close-on-click-overlay="false"
      v-model="show"
    >
      <Tals
        :fom="details"
        :detail="detail"
        @dateOpen="dateOpen"
        @balanceShow="balanceShow"
        @payShow="payShow"
        @planAlertse="planAlertse"
      />
    </van-action-sheet>
    <van-action-sheet
      style="
        background-image: linear-gradient(to left, #198aff, #79bbff);
        color: #ffffff;
      "
      :title="title"
      :close-on-click-overlay="false"
      v-model="showSpeed"
    >
      <div style="background: #f2f3f5">
        <div style="padding: 10px">
          <div style="background: #ffffff; border-radius: 5px; padding: 10px">
            <img v-if="vipList.length==1" src="../assets/speed.jpg" style="width: 100%" alt="" />
            <div class="vipBoxNew" v-if="vipList.length>1">
        <div v-for="item  in  vipList" :key="item.id" style="width: 47%;">
          <div class="vipBoxNew-item">
            <img
          class="imageBoxNew"
          @click="setChecks(item)"
          :src="item.path?item.path:require('@/assets/vip.jpg')"
        ></img>
        <div class="yBoxNew" v-if="item.id==speedVipId">
          已选中
        </div>
          </div>
        </div>
        <div style="width: 47%;"></div>
      </div>
            <div
              style="
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 40px; height: 32px"
                  src="../assets/speed-left.png"
                  alt=""
                />
                <div
                  style="
                    color: #000;
                    margin-left: 10px;
                    font-size: 18px;
                    font-weight: 700;
                  "
                >
                  特享会员权益
                </div>
              </div>
              <div style="font-size: 16px; color: #009fff">
                {{ speedForm.money }}元/{{ speedForm.day }}天
              </div>
            </div>
            <img
              style="width: 100%; margin-top: 10px"
              src="../assets/bottom.png"
              alt=""
            />
            <!-- <div
              style="
                display: flex;
                justify-content: center;
                margin-top: 10px;
                font-size: 15px;
              "
            >
              <div
                style="
                  padding: 10px;
                  border-radius: 5px;
                  border: 1px solid #e9e9e9;
                  display: flex;
                "
              >
                <div
                  @click="reduceNum"
                  style="
                    width: 25px;
                    height: 25px;
                    background-color: #a9a9a9;
                    text-align: center;
                    line-height: 25px;
                  "
                >
                  -
                </div>
                <div
                  style="
                    width: 75px;
                    height: 25px;
                    background-color: #a9a9a9;
                    text-align: center;
                    line-height: 25px;
                    padding: 0 10px;
                    margin: 0 10px;
                  "
                >
                  {{ speedNum }}月
                </div>
                <div
                  @click="addNum"
                  style="
                    width: 25px;
                    height: 25px;
                    background-color: #a9a9a9;
                    text-align: center;
                    line-height: 25px;
                  "
                >
                  +
                </div>
              </div>
            </div> -->
          </div>
          <div
            style="
              background: #ffffff;
              border-radius: 5px;
              padding: 10px;
              margin-top: 10px;
              color: #000;
              font-size: 15px;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-bottom: 10px;
                border-bottom: 1px solid #e9e9e9;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 20px; height: 20px"
                  src="../assets/前端/微信图片_20210606190140.png"
                  alt=""
                />
                <span style="margin-left: 10px">余额支付</span>
              </div>
              <van-radio-group v-model="payRadio">
                <van-radio :name="0"></van-radio>
              </van-radio-group>
            </div>
            <div
              v-for="item in newPayList"
              :key="item.id"
              style="
                display: flex;
                justify-content: space-between;
                padding-bottom: 10px;
                border-bottom: 1px solid #e9e9e9;
                margin-top: 10px;
              "
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 20px; height: 20px"
                  :src="item.imageUrl"
                  alt=""
                />
                <span style="margin-left: 10px">{{ item.name }}</span>
                <div class="recommend">
                  <div v-if="item.appRecommend == 1" class="recommends">
                    推荐
                  </div>
                </div>
              </div>
              <van-radio-group v-model="payRadio">
                <van-radio :name="item.id"></van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div
          style="
            background: #ffffff;
            height: 47px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div
            style="
              font-size: 16px;
              color: #000;
              line-height: 47px;
              text-align: center;
              margin-left: 10px;
            "
          >
            总计：￥{{ (speedNum * speedForm.money).toFixed(2) }}
          </div>
          <div
            @click="speedPay"
            style="
              font-size: 16px;
              background-color: #009fff;
              width: 111px;
              text-align: center;
              line-height: 47px;
            "
          >
            确认支付
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet
      :close-on-click-overlay="false"
      :title="title"
      v-model="shows"
      @cancel="onCancel"
    >
      <Banlance :detail="banlances" />
    </van-action-sheet>
    <!-- 极速会员支付商户弹窗 -->
    <van-dialog
      v-model="speedShows"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <div style="font-size: 18px; margin-top: 10px">支付金额</div>

      <div style="font-size: 20px; color: red; margin-top: 10px">
        <div>￥{{ (speedNum * speedForm.money).toFixed(2) }}元</div>
      </div>
      <div style="margin-top: 10px">
        <van-radio-group v-model="payObj.radio">
          <div v-for="(item, index) in speedList" :key="item.name">
            <div
              :class="index == speedList.length - 1 ? 'content' : 'contenta'"
            >
              <div class="display-left">
                <img class="imgs" :src="item.imgUrl" alt="" />
                {{ item.showName }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div style="width: 100%">
        <van-button
          @click="confirmPays"
          size="normal"
          style="width: 80%; margin: 20px 10%; border-radius: 10px"
          type="info"
        >
          确认支付
        </van-button>
      </div>
    </van-dialog>
    <!-- 极速会员余额支付弹窗 -->
    <van-dialog
      v-model="speedShow1"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <p style="font-size: 18px">支付金额</p>
      <div style="font-size: 20px; color: red; margin-top: 10px">
        <div>￥{{ (speedNum * speedForm.money).toFixed(2) }}元</div>
      </div>
      <div style="width: 100%; margin: 10px 0">
        <van-field
          v-model="value"
          type="number"
          style="
            width: 80%;
            background-color: #f5f5f5;
            margin: 10px 10%;
            border-radius: 10px;
          "
          placeholder="请输入支付密码"
        />
      </div>
      <div style="width: 100%">
        <van-button
          @click="balancePays"
          size="normal"
          style="width: 80%; margin: 10px 10%; border-radius: 10px"
          type="info"
        >
          确认支付
        </van-button>
      </div>
      <div
        style="color: red; font-size: 18px; margin: 10px 0; margin-bottom: 20px"
      >
        默认支付密码：123456
      </div>
    </van-dialog>
    <van-action-sheet
      v-model="showe"
      title="网络优选"
      style="background-color: #009fff; color: aliceblue"
    >
      <div class="content">
        <div style="text-align: left">
          <div>
            <div>
              <span style="margin-right: 5px; width: 60%">智能优选网络</span>
              <el-tag size="mini" type="danger" effect="dark">推荐</el-tag>

              <div style="font-size: 15spx; color: darkgray">
                根据三网信号状况，优选最佳网络
              </div>
            </div>
            <span style="float: right; margin-top: -30px">
              <el-radio v-model="radio" size="medium" label="三网通">
                <br />
              </el-radio>
            </span>
          </div>
        </div>
      </div>
      <div v-for="item in listS" :key="item.id" class="content">
        <div style="text-align: left">
          <span>{{ item.name }}</span>
          <el-radio
            style="float: right; margin-top: 2px"
            v-model="radio"
            size="medium"
            :label="item.name"
          >
            <br />
          </el-radio>
        </div>
      </div>
      <div class="contents">
        <van-button style="width: 100%" @click="edit" round type="info">
          确认修改
        </van-button>
      </div>
    </van-action-sheet>
    <Tab></Tab>
    <van-dialog
      v-model="showes"
      title="实名登记"
      closeOnClickOverlay
      :showConfirmButton="false"
    >
      <p>
        {{
          details.realNameCard
            ? "请复制卡号，然后点击实名"
            : "请使用这个卡号进行实名"
        }}
      </p>
      <div
        style="
          margin: 10px;
          border-radius: 20px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
        "
      >
        <input
          id="hao1"
          v-model="details.iccId"
          readonly
          style="
            text-align: center;

            width: 75%;
            margin: 10px auto;
            border: 0;
          "
          type="text"
        />
        <span
          @click="copysec"
          v-if="details.realNameCard"
          style="color: #1890ff; font-size: 13px"
        >
          复制
        </span>
      </div>
      <div
        v-if="details.realNameCard"
        style="
          margin: 10px;
          border-radius: 20px;
          box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
        "
      >
        <input
          id="0361"
          v-model="details.realNameCard"
          readonly
          style="
            text-align: center;
            width: 75%;
            margin: 10px auto;

            border: 0;
          "
          type="text"
        />
        <span @click="copyse" style="color: #1890ff; font-size: 13px">
          复制
        </span>
      </div>
      <van-button
        v-if="details.realNameCard"
        @click="copys"
        style="width: 80%; margin: 20px auto"
        round
        type="info"
      >
        实名
      </van-button>
      <van-button
        v-else
        @click="copys"
        style="width: 80%; margin: 20px auto"
        round
        type="info"
      >
        一键复制去实名
      </van-button>
    </van-dialog>
    <!-- 支付宝二维码 -->
    <van-action-sheet v-model="showss" cancel-text="取消" close-on-click-action>
      <img style="width: 100%" :src="imagerurl" />
      <div style="text-align: center">
        使用{{ payObj.posType == 1 ? "微信" : "支付宝" }}扫一扫打开
      </div>
    </van-action-sheet>
    <!-- 支付商户弹窗 -->
    <van-dialog
      v-model="payObj.posShow"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <div style="font-size: 18px; margin-top: 10px">支付金额</div>

      <div style="font-size: 20px; color: red; margin-top: 10px">
        <div>
          ￥{{
            Math.floor(
              (detail.speedShow == true
                ? detail.couponEndPrice + payObj.vipMoney
                : detail.couponEndPrice) * 100
            ) / 100
          }}元
        </div>
      </div>
      <div style="margin-top: 10px">
        <van-radio-group v-model="payObj.radio">
          <div v-for="(item, index) in payObj.newPayListItem" :key="item.name">
            <div
              :class="
                index == payObj.newPayListItem.length - 1
                  ? 'content'
                  : 'contenta'
              "
            >
              <div class="display-left">
                <img class="imgs" :src="item.imgUrl" alt="" />
                {{ item.showName }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div style="width: 100%">
        <van-button
          @click="confirmPay"
          size="normal"
          style="width: 80%; margin: 20px 10%; border-radius: 10px"
          type="info"
        >
          确认支付
        </van-button>
      </div>
    </van-dialog>
    <!-- 余额支付弹窗 -->
    <!-- 余额支付弹窗 -->
    <van-dialog
      v-model="balanceObj.show"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <p style="font-size: 18px">支付金额</p>
      <span style="font-size: 18px; color: red">
        <div>￥{{ balanceObj.balance }}元</div>
      </span>

      <div v-if="balanceObj.type == ''" style="width: 100%; margin: 10px 0">
        <van-field
          v-model="value"
          type="number"
          style="
            width: 80%;
            background-color: #f5f5f5;
            margin: 10px 10%;
            border-radius: 10px;
          "
          placeholder="请输入支付密码"
        />
      </div>
      <div v-else style="margin-top: 10px">
        <van-radio-group v-model="payShopCheck">
          <div
            v-for="item in balanceObj.newPayList"
            :key="item.name"
            class="content"
          >
            <div class="display-left">
              <img
                style="width: 20px; height: 20px"
                :src="item.imageUrl"
                alt=""
              />
              {{ item.name }}
            </div>
            <div class="recommend">
              <div v-if="item.recommend == 1" class="recommends">推荐</div>
            </div>
            <van-radio class="display-right" :name="item.id"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <div style="width: 100%">
        <van-button
          @click="balancePay"
          size="normal"
          style="
            width: 80%;
            margin: 10px 10%;

            border-radius: 10px;
          "
          type="info"
        >
          确认支付
        </van-button>
      </div>

      <div
        v-if="balanceObj.type == ''"
        style="color: red; font-size: 18px; margin: 10px 0; margin-bottom: 20px"
      >
        默认支付密码：123456
      </div>
    </van-dialog>
    <!-- 余额支付商户弹窗 -->
    <van-dialog
      v-model="payShows"
      :showConfirmButton="false"
      closeOnClickOverlay
    >
      <div style="font-size: 18px; margin-top: 10px">支付金额</div>
      <div style="font-size: 20px; color: red; margin-top: 10px">
        <div>￥{{ balanceObj.balance }}元</div>
      </div>

      <div style="margin-top: 10px">
        <van-radio-group v-model="payShopChecks">
          <div v-for="item in balancePayList" :key="item.name" class="content">
            <div class="display-left">
              <img
                style="width: 20px; height: 20px"
                :src="item.imgUrl"
                alt=""
              />
              {{ item.showName }}
            </div>
            <div class="recommend">
              <div v-if="item.recommend == 1" class="recommends">推荐</div>
            </div>
            <van-radio class="display-right" :name="item.id"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <div style="width: 100%">
        <van-button
          @click="confirmPayBalance"
          size="normal"
          style="width: 80%; margin: 20px 10%; border-radius: 10px"
          type="info"
        >
          确认支付
        </van-button>
      </div>
    </van-dialog>
    <!-- 跳转充值余额 -->
    <van-dialog
      v-model="banlancesaaa"
      show-cancel-button
      confirmButtonText="确认充值"
      cancelButtonText="放弃充值"
      @confirm="banlance"
      @cancel="banlancesaaa = false"
    >
      <div style="padding: 10px; font-size: 20px">温馨提示</div>
      <div style="padding: 10px">
        您的账户余额不足，请充值余额后再进行充值套餐充值余额有优惠哦
      </div>
    </van-dialog>
    <!-- 套餐营销 -->
    <van-dialog
      v-if="planAlert == true"
      v-model="planAlert"
      show-cancel-button
      confirmButtonText="充值推荐套餐"
      cancelButtonText="关闭弹窗"
      @confirm="routers11(detail)"
      @cancel="cancel2(detail)"
    >
      <div
        @click="showImages($event)"
        class="titleas111111111111"
        v-html="detail.planModel.setMealMarket"
      ></div>
    </van-dialog>
    <!-- 余额营销 -->
    <van-dialog
      v-if="planAlerts == true"
      v-model="planAlerts"
      show-cancel-button
      confirmButtonText="立即充值余额"
      cancelButtonText="关闭弹窗"
      @confirm="confirm1"
      @cancel="cancel1"
    >
      <div
        @click="showImages($event)"
        class="titleas111111111111"
        v-html="detail.planModel.balanceMarket"
      ></div>
    </van-dialog>
    <!-- 优惠券提示 -->
    <van-dialog
      v-if="details.seriesCouponModel"
      v-model="Alerts"
      show-cancel-button
      confirmButtonText="继续参加优惠活动"
      cancelButtonText="放弃优惠原价订购"
      @confirm="about"
      @cancel="Alerts = false"
    >
      <div
        @click="showImages($event)"
        class="titleas111111111111"
        v-html="details.seriesCouponModel.couponTips"
      ></div>
    </van-dialog>
    <!-- 官方实名提示 -->
    <van-popup
      style="font-size: 16px; width: 84%"
      v-if="fom.officialRealName != 0"
      v-model="offAlerts"
      :close-on-click-overlay="false"
      round
    >
      <div style="padding-top: 15px">温馨提示</div>
      <div style="padding: 15px">
        您未官方实名，请立即进行官方实名操作，官方实名后才可以使用，若已实名请点击刷新获取最新实名状态
        <span style="color: #1890ff" @click="getRealName(details.id)">
          [点此刷新]
        </span>
      </div>
      <div
        style="
          box-sizing: border-box;
          width: 100%;
          padding: 13px;
          color: red;
          border-top: 1px solid #cccccc;
        "
        @click="opi"
      >
        立即实名
      </div>
    </van-popup>
    <!-- 生效周期弹窗 -->
    <van-dialog
      v-if="dateTime.showfg"
      v-model="dateTime.showfg"
      @confirm="plmo"
      :confirmButtonText="
        times > 0 ? '请仔细査看生效时间(' + times + 's)' : '已确认时间'
      "
      :before-close="beforeClose"
      confirmButtonColor="red"
      title="生效周期"
    >
      <div style="margin-top: 20px">开始时间：{{ dateTime.satrtTime }}</div>
      <div style="margin-top: 20px; margin-bottom: 20px">
        结束时间：{{ dateTime.endTime }}
      </div>
      <!-- <div style="color: red; margin-top: 20px; margin-bottom: 20px">
        谨慎订购,误订不退款
      </div> -->
    </van-dialog>
    <van-image-preview
      v-model="showImage"
      :images="[images]"
    ></van-image-preview>
    <!-- 二维码 -->
    <van-action-sheet
      v-model="showsss"
      cancel-text="取消"
      close-on-click-action
    >
      <img style="width: 100%" :src="imagerurl" />
      <div style="text-align: center">
        使用{{ payShopCheck == 1 ? "微信" : "支付宝" }}扫一扫打开
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import { realAddress, getThirdPartyUrl } from "@/api/user/index.js";
  import { getAll, clientGet } from "@/api/seting";
  import {
    refreshPhone,
    phoneSimCard,
    updateFalseOp,
    phoneGetMeal,
    getCategorySetMeal,
    phoneGetMeals,
    getRealName,
    phoneSimCarda,
  } from "@/api/cardOperation";
  import {
    getPayList,
    sendSetMeal,
    addOrders,
    speedMembership,
    paySpeedMember,
    balancePurchase,
    xiaoBaiYuanPay,
  } from "@/api/newPay";
  import { Loading } from "element-ui";
  import Tals from "@/views/Detail.vue";
  import Tab from "@/components/Tab.vue";
  import Banlance from "@/views/Banlance.vue";
  import { Dialog } from "vant";
  export default {
    data() {
      return {
        speedVipId:"",
        showsss: false,
        speedForm: {
          money: 100,
        },
        speedShows: false,
        speedShow1: false,
        speedList: [],
        speedRadio: 1,
        payRadio: 0,
        showSpeed: false,
        banlancesaaa: false,
        nameAlerts: false,
        Alerts: false,
        offAlerts: false,
        images: "",
        showImage: false,
        planAlert: false,
        planAlerts: false,
        //二维码地址
        imagerurl: "",
        //二维码弹窗
        showss: false,
        //生效时间
        dateTime: {},
        //余额支付
        balanceObj: {},
        //余额支付金额
        value: "",
        //商户对象
        payObj: {},
        //是否传code
        code: "",
        //商户appid
        appId: "",
        detail: { planModel: { setMealMarket: "" } },
        cc: [],
        kefuurl: "",
        details: {
          seriesCouponModel: {
            couponTips: "",
          },
          seriesModel: {
            speedMembershipId: "",
          },
        },
        listS: [],
        three: [
          {
            id: 1,
            name: "中国移动",
          },
          {
            id: 2,
            name: "中国联通",
          },
          {
            id: 3,
            name: "中国电信",
          },
          {
            id: 5,
            name: "中国广电",
          },
        ],
        show: false,
        shows: false,
        title: "",
        price: [],
        giveBalance: "",
        balance: "",
        banlances: {},
        showe: false,
        radio: 1,
        tel: "",
        tel1: "",
        zuo: "",
        biaoshi: 0,
        showes: false,
        realurl: "",
        switchs: 0,
        form: {
          random: "",
          phone: "",
          meCardNum: localStorage.getItem("meCardNum"),
          identityCard: "",
          name: "",
        },
        iccid: this.$route.params.iccId,
        dd: false,
        a: "",
        s: 0,
        time: 60 * 1000,
        officialAccount: "",
        fom: {},
        enm: "",
        newPayList: [],
        speedNum: 1,
        times: 3,
        payShopCheck: "",
        payShopChecks: "",
        balancePayList: [],
        payShows: false,
        vipList:[]
      };
    },
    components: {
      Tals,
      Banlance,
      Tab,
    },
    async created() {
      if (this.$route.query.card) {
        localStorage.removeItem("meCardNum");
        localStorage.setItem("meCardNum", this.$route.query.card);
      }
      await this.is_weixn();
      await this.getPayList();
    },
    async mounted() {
      await Loading.service();
      if (this.$route.query.speed) {
        this.wxs(this.$route.query.code, 0, this);
      } else if (this.$route.query.code) {
        this.wx(this.$route.query.code, 0, this);
      }
      await this.phoneMeal();
      await this.ssse();
      await this.phoneSimCard();
      await this.url();
    },
    methods: {
      setChecks(val){
        this.speedVipId=val.id
        this.speedForm=val
      },
      //拉起支付
      xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6) {
        xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6).then((res) => {
          if (res.status == true) {
            if (res.data.payType == 2) {
              if (this.isWeiXin()) {
                this.show = false;
                this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                  res.data.body
                )}`;
                this.showss = true;
              } else {
                window.location.href = res.data.body;
              }
            } else if (res.data.payType == 3) {
              this.show = false;
              this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                res.data.body
              )}`;
              this.showsss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      confirmPayBalance() {
        localStorage.removeItem("next");
        localStorage.setItem("next", this.balanceObj.next);
        localStorage.removeItem("meal");
        localStorage.setItem("meal", this.balanceObj.id);
        localStorage.removeItem("meall1");
        localStorage.setItem("meall1", this.balanceObj.balance);
        this.balancePayList.forEach((item) => {
          if (this.payShopChecks == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });
        console.log(this.payShopCheck, "看看参数");
        console.log(this.codes, "看看参数");
        console.log(this.payShopChecks, "看看参数");
        console.log(this.isWeiXin(), "看看参数");
        if (
          this.isWeiXin() == true &&
          this.codes == 0 &&
          this.payShopCheck == 1
        ) {
          this.wx(null, 1, this);
        } else {
          if (this.codes == 0) {
            this.payShows = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?balance=${
                  this.balanceObj.balance
                }&payId=${this.payShopChecks}&card=${localStorage.getItem(
                  "meCardNum"
                )}&appId=${this.appId}&balances=${1}&setMealId=${
                  this.balanceObj.id
                }&next=${this.balanceObj.next}&flag=${this.balanceObj.shows}`
              )}`;
            this.showsss = true;
          } else {
            this.payShows = false;
            this.xiaoBaiYuanPay(
              this.balanceObj.balance,
              this.payShopChecks,
              "",
              "MWEB",
              this.balanceObj.id,
              this.balanceObj.next,
              this.balanceObj.shows
            );
          }
        }
      },
      speedPay() {
        if (this.payRadio == 0) {
          this.speedShow1 = true;
          this.showSpeed = false;
        } else {
          this.newPayList.forEach((item) => {
            if (item.id == this.payRadio) {
              this.speedList = item.list;
              this.speedRadio = item.list[0].id;
            }
          });
          this.showSpeed = false;
          this.speedShows = true;
        }
      },
      addNum() {
        this.speedNum++;
      },
      reduceNum() {
        if (this.speedNum == 1) {
          this.$toast.fail("最少购买一个月");
        } else {
          this.speedNum--;
        }
      },
      is_weixn() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.enm = 3;
          return (this.qqs = true);
        } else {
          this.enm = 2;
          return (this.qqs = false);
        }
      },
      //获取新支付列表
      getPayList() {
        getPayList(this.enm).then((res) => {
          res.data.forEach((item) => {
            item.list.forEach((items) => {
              items.imgUrl = item.imageUrl;
            });
          });
          this.newPayList = res.data;
        });
      },
      speedRouter() {
        if (this.details.seriesModel.speedMembershipIds) {
          speedMembership(this.details.meCardNum).then((res) => {
            this.vipList=res.data
            this.speedVipId=res.data[0].id
            this.speedForm = res.data[0];
            this.speedNum = 1;
            this.showSpeed = true;
            if (this.newPayList.length > 0) {
              this.payRadio = this.newPayList[0].id;
            } else {
              this.payRadio = 0;
            }
          });
        }
      },
      changse() {
        updateRealType(this.form).then((res) => {
          if (res.status) {
            this.nameAlerts = false;
            this.$notify({
              type: "success",
              message: res.msg,
            });
          } else {
            this.$notify({
              type: "warning",
              message: res.msg,
            });
          }
        });
      },
      finishss() {
        this.dd = false;
      },
      start() {
        this.$nextTick(() => {
          this.$refs.count0.start();
        });
      },

      change() {
        if (this.form.phone == "") {
          this.$notify({
            type: "warning",
            message: `手机号不能为空`,
          });
        } else {
          VerificationCode(this.form.phone).then((res) => {
            if (res.status) {
              console.log(res);
              this.$notify({
                type: "success",
                message: res.msg,
              });
              this.dd = true;
              this.start();
            } else {
              this.$notify({
                type: "warning",
                message: res.msg,
              });
            }
          });
        }
      },
      beforeClose() {
        if (this.offAlerts == false) {
        } else {
        }
      },
      getRealName(val) {
        const ste = this.$toast.loading({
          message: "正在更新数据，请稍后...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        getRealName(val)
          .then((res) => {
            if (res.status) {
              ste.clear();
              this.phoneSimCard();
              s;
            }
          })
          .catch(() => {
            ste.clear();
          });
      },
      about() {
        this.$router.push("/discount");
      },
      showImages(e) {
        if (e.target.tagName == "IMG") {
          this.images = e.target.src;
          this.showImage = true;
        }
      },
      planAlertse(val) {
        if (val.shows !== undefined) {
          this.detail.speedShow = val.shows;
        }
        this.planAlerts = val;
      },
      cancel1() {
        localStorage.setItem("balanceshow", 1);
      },
      confirm1() {
        this.$router.push(`/recharge`);
      },
      routers11(s) {
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        phoneGetMeals(s.planModel.appointSetMealId).then((res) => {
          if (res.status) {
            if (res.data.seriesModel.speedMembershipList) {
              if (res.data.seriesModel.speedMembershipList.length > 0) {
                res.data.speedShow = true;
                res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
              }
            } else {
              res.data.speedShow = false;
            }

            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 0;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;

              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            // this.changess();
            localStorage.removeItem("balanceshow");
            this.detail.biaoshi = 0;
            this.show = true;
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
      },

      cancel2(s) {
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        phoneGetMeals(s.id).then((res) => {
          if (res.status) {
            if (res.data.seriesModel.speedMembershipList) {
              if (res.data.seriesModel.speedMembershipList.length > 0) {
                res.data.speedShow = true;
                res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
              }
            } else {
              res.data.speedShow = false;
            }

            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 0;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;

              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            // this.changess();
            localStorage.removeItem("balanceshow");
            this.detail.biaoshi = 0;
            this.show = false;
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
      },
      //支付商户弹窗
      payShow(val) {
        if (val.shows !== undefined) {
          this.detail.speedShow = val.shows;
        }
        this.show = false;
        this.payObj = val;
      },
      //极速会员余额支付
      balancePays() {
        if (this.value === "") {
          this.$toast.fail("密码不能为空");
        } else {
          var st = this.$toast.loading({
            message: "正在支付中，请稍后...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          balancePurchase(this.value, this.speedNum,this.speedForm.id)
            .then((res) => {
              st.clear();
              if (res.status) {
                this.phoneSimCard();
                this.speedShow1 = false;
                // this.card = this.$route.params.card;
                this.$dialog
                  .alert({
                    message: res.msg,
                  })
                  .then(() => {
                    // on close
                  });
                this.value = "";
              } else {
                if (res.msg === "账户余额不足") {
                  this.$dialog
                    .confirm({
                      message:
                        "账户余额小于要支付的金额点击确认跳转余额充值界面",
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                    })
                    .then((res) => {
                      this.$router.push(`/recharge`);
                    })
                    .catch(() => {
                      // on cancel
                    });
                }
              }
            })
            .catch(() => {
              st.clear();
            });
        }
      },
      //余额支付
      balancePay() {
        if (this.balanceObj.type != "") {
          this.balanceObj.show = false;
          this.balanceObj.newPayList.forEach((item) => {
            if (item.id == this.payShopCheck) {
              this.payShopChecks = item.list[0].id;
              this.balancePayList = item.list;
            }
          });
          this.payShows = true;
        } else {
          if (this.value === "") {
            this.$toast.fail("密码不能为空");
          } else {
            var st = this.$toast.loading({
              message: "正在支付中，请稍后...",
              forbidClick: true,
              loadingType: "spinner",
              duration: 0,
            });

            addOrders(
              this.balanceObj.id,
              this.value,
              "",
              this.balanceObj.next == false ? 0 : 1,
              this.balanceObj.shows?this.balanceObj.shows:false,
              this.balanceObj.vipId
            )
              .then((res) => {
                if (res.status) {
                  this.phoneSimCard();
                  st.clear();
                  this.balanceObj.show = false;
                  // this.card = this.$route.params.card;
                  this.$dialog
                    .alert({
                      message: res.msg,
                    })
                    .then(() => {
                      // on close
                    });
                  this.value = "";
                  localStorage.removeItem("next");
                  localStorage.removeItem("flag");
                } else {
                  st.clear();
                  if (res.msg === "账户余额不足") {
                    this.$dialog
                      .confirm({
                        message:
                          "账户余额小于要支付的套餐金额点击确认跳转余额充值界面",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                      })
                      .then((res) => {
                        this.$router.push(`/recharge`);
                      })
                      .catch(() => {
                        // on cancel
                      });
                  }
                }
              })
              .catch((res) => {
                st.clear();
              });
          }
        }
      },
      //拉起支付
      sendSetMeal(mealId, payId, code, next, payType, val, vipId) {
        sendSetMeal(mealId, payId, code, next, payType, val, vipId).then(
          (res) => {
            if (res.status) {
              this.phoneSimCard();
              if (res.data.payType == 2) {
                window.location.href = res.data.body;
              } else if (res.data.payType == 3) {
                console.log(res.data.body);
                this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                  res.data.body
                )}`;
                console.log(this.imagerurl);
                this.payObj.posShow = false;
                this.showss = true;
              }
            } else {
              this.$toast(res.msg);
            }
          }
        );
      },
      //极速会员确认支付
      confirmPays() {
        this.speedList.forEach((item) => {
          if (this.speedRadio == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });
        if (this.isWeiXin() == true && this.codes == 0 && this.payRadio == 1) {
          this.wxs(null, 1, this);
        } else {
          if (this.codes == 0) {
            this.speedShows = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?payId=${
                  this.speedRadio
                }&speed=${1}&num=${this.speedNum}&appId=${
                  this.appId
                }&speedMemberId=${this.speedForm.id}&card=${localStorage.getItem("meCardNum")}`
              )}`;
            this.showss = true;
          } else {
            paySpeedMember(this.speedRadio, "", "MWEB", this.speedNum,this.speedForm.id).then(
              (res) => {
                if (res.status) {
                  this.phoneSimCard();
                  if (res.data.payType == 2) {
                    window.location.href = res.data.body;
                  } else if (res.data.payType == 3) {
                    console.log(res.data.body);
                    this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                      res.data.body
                    )}`;
                    console.log(this.imagerurl);
                    this.payObj.posShow = false;
                    this.showss = true;
                  }
                } else {
                  this.$toast(res.msg);
                }
              }
            );
          }
        }
      },
      //确认支付
      confirmPay() {
        localStorage.removeItem("next");
        localStorage.setItem("next", this.payObj.next);
        localStorage.removeItem("meal");
        localStorage.setItem("meal", this.payObj.id);
        localStorage.removeItem("vipId");
        localStorage.setItem("vipId", this.payObj.vipId);
        this.payObj.newPayListItem.forEach((item) => {
          if (this.payObj.radio == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });
        if (
          this.isWeiXin() == true &&
          this.codes == 0 &&
          this.payObj.posType == 1
        ) {
          this.wx(null, 1, this);
        } else {
          if (this.codes == 0) {
            this.payObj.posShow = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?mealId=${this.payObj.id}&payId=${
                  this.payObj.radio
                }&card=${localStorage.getItem("meCardNum")}&appId=${
                  this.appId
                }&next=${this.payObj.next}&flag=${this.payObj.shows}&vipId=${
                  this.payObj.vipId
                }&meal=${1}`
              )}`;
            this.showss = true;
          } else {
            this.sendSetMeal(
              this.payObj.id,
              this.payObj.radio,
              "",
              this.payObj.next,
              "MWEB",
              this.payObj.shows,
              this.payObj.vipId
            );
          }
        }
      },
      //余额支付弹窗
      balanceShow(val) {
        this.show = false;
        this.value = "";
        this.balanceObj = val;
        this.payShopCheck = this.balanceObj.newPayList[0].id;
      },
      //子组件获取生效时间
      dateOpen(val) {
        this.times = 3;
        this.dateTime = val;
        const interval = setInterval(() => {
          if (this.times > 0) {
            this.times--;
          } else {
            clearInterval(interval);
          }
        }, 1000);
      },

      // 余额充值倒计时
      startTimer() {},
      //已知晓生效时间
      plmo() {
        if (this.times <= 0) {
          this.dateTime.showfg = false;
          this.dateTime.plok = 1;
        } else {
          this.dateTime.showfg = true;
        }
      },
      beforeClose(action, done) {
        if (action === "confirm" && this.times > 0) {
          return done(false);
        } else {
          this.dateTime.showfg = false;
          this.dateTime.plok = 1;
        }
      },
      isWeiXin() {
        var ua = navigator.userAgent.toLowerCase();
        // console.log(ua)
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return (this.qqs = true);
        } else {
          return (this.qqs = false);
        }
      },
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type, payType) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
              payType: payType,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                Dialog.alert({
                  message: "充值成功",
                }).then(() => {
                  window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/appRedirect/" +
                    `?card=${localStorage.getItem(
                      "meCardNum"
                    )}&routeAddress=${encodeURIComponent(
                      "/wap/index.html#/recharges"
                    )}`;
                });
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                Dialog.alert({
                  message: "取消充值",
                }).then(() => {
                  window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/appRedirect/" +
                    `?card=${localStorage.getItem(
                      "meCardNum"
                    )}&routeAddress=${encodeURIComponent(
                      "/wap/index.html#/recharges"
                    )}`;
                });
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                Dialog.alert({
                  message: "充值失败",
                }).then(() => {
                  window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/appRedirect/" +
                    `?card=${localStorage.getItem(
                      "meCardNum"
                    )}&routeAddress=${encodeURIComponent(
                      "/wap/index.html#/recharges"
                    )}`;
                });
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wxs(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''

          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/appRedirect/" +
              `?&payId=${than.speedRadio}&speed=${1}&num=${
                than.speedNum
              }&vipId=${
                than.speedForm.id
              }&routeAddress=${encodeURIComponent(
                "/wap/index.html#/recharges"
              )}`
          );
          // alert(than.detail.next);
          // than.detail.next = localStorage.getItem("next");
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
          // alert(localStorage.getItem("next"));
          // than.detail.next = localStorage.getItem("next");
        }
        getUserInfo();

        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            paySpeedMember(
              than.$route.query.payId,
              code,
              s,
              than.$route.query.num,
              than.$route.query.vipId
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;
                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
              // than.detail.next = localStorage.getItem("next");
              // alert(than.detail.next);
            }
          }
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''
          var url = "";
          if (than.payShopCheck !== "") {
            url = encodeURIComponent(
              window.location.protocol +
                "//" +
                window.location.host +
                "/appRedirect/" +
                `?card=${localStorage.getItem("meCardNum")}&payId=${
                  than.payShopChecks
                }&next=${localStorage.getItem(
                  "next"
                )}&flags=${localStorage.getItem(
                  "flag"
                )}&vipId=${localStorage.getItem(
                  "vipId"
                )}&balance=${localStorage.getItem(
                  "meall1"
                )}&recharge=${1}&routeAddress=${encodeURIComponent(
                  "/wap/index.html#/recharges"
                )}`
            );
          } else {
            url = encodeURIComponent(
              window.location.protocol +
                "//" +
                window.location.host +
                "/appRedirect/" +
                `?card=${localStorage.getItem("meCardNum")}&payId=${
                  than.payObj.radio
                }&next=${localStorage.getItem(
                  "next"
                )}&flags=${localStorage.getItem(
                  "flag"
                )}&vipId=${localStorage.getItem(
                  "vipId"
                )}&biaoShi=${1}&recharge=${1}&routeAddress=${encodeURIComponent(
                  "/wap/index.html#/recharges"
                )}`
            );
          }

          // alert(than.detail.next);
          // than.detail.next = localStorage.getItem("next");
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
          // alert(localStorage.getItem("next"));
          // than.detail.next = localStorage.getItem("next");
        }

        getUserInfo();

        function getUserInfo() {
          if (
            code != null &&
            code != undefined &&
            code.trim() != "" &&
            than.$route.query.biaoShi
          ) {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            sendSetMeal(
              Number(localStorage.getItem("meal")),
              than.$route.query.payId,
              code,
              than.$route.query.next,
              s,
              localStorage.getItem("flag"),
              localStorage.getItem("vipId")
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;

                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else if (
            code != null &&
            code != undefined &&
            code.trim() != "" &&
            than.$route.query.recharge
          ) {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            xiaoBaiYuanPay(
              than.$route.query.balance,
              than.$route.query.payId,
              code,
              s,
              Number(localStorage.getItem("meal")),
              than.$route.query.next,
              localStorage.getItem("flag")
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;

                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          }
          {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      copyse() {
        // console.log(val);
        let input = document.createElement("input");
        input.value = this.fom.realNameCard;
        input.id = "creatDom";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      copysec() {
        // console.log(val);
        let input = document.createElement("input");
        input.value = this.fom.iccId;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        // ===========================
        this.$notify({ type: "success", message: "复制成功!" });
      },
      opi() {
        this.offAlerts = true;
        if (this.fom.realnameModel) {
          if (this.fom.seriesModel.realNameJudge == 0) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.offAlerts = true;
              this.showes = true;
            }
          } else if (
            this.fom.seriesModel.realNameJudge == 1 &&
            this.fom.officialRealName != 0
          ) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              this.copys();
            } else {
              this.offAlerts = true;
              this.showes = true;
            }
          } else if (
            this.fom.seriesModel.realNameJudge == 1 &&
            this.fom.officialRealName == 0
          ) {
           if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
          } else if (this.fom.seriesModel.realNameJudge == 2) {
            if (this.fom.isPay == true && this.fom.officialRealName != 0) {
              if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.showes = true;
              }
            } else if (this.fom.isPay == false) {
              this.$toast.fail("该卡未充值，请充值后再进行官方实名");
            } else if (
              this.fom.isPay == true &&
              this.fom.officialRealName == 0
            ) {
               if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
            }
          } else if (this.fom.seriesModel.realNameJudge == 3) {
            if (
              this.fom.isPay == true &&
              this.fom.officialRealName != 0 &&
              this.fom.isTheMonth == true
            ) {
              if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
            } else if (this.fom.officialRealName == 0) {
              if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
            } else {
              this.$toast.fail("没有有效期订单，不允许官方实名");
            }
          } else if (this.fom.officialRealName == 0) {
             if (this.fom.seriesModel.realNameAlert == 1) {
                this.copys();
              } else {
                this.offAlerts = true;
                this.showes = true;
              }
          } else {
            this.$toast.fail("请联系管理员");
          }
        } else {
          this.$router.push({
            name: "Registers",
            params: {
              type: this.fom.seriesModel.type,
              url: this.realurl,
              iccId: this.fom.iccId,
              types: this.fom.seriesModel.realNameType,
              realNameJudge: this.fom.seriesModel.realNameJudge,
              isPay: this.fom.isPay,
              isTheMonth: this.fom.isTheMonth,
            },
          });
        }
      },
      async cop() {
        await this.copyse();
        await this.copysec();
      },
      copys() {
        console.log(this.details);
        if (this.fom.seriesModel.realNameType != 4) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            if (this.fom.realNameCard) {
              this.cop();
            } else {
              this.copysec();
            }
          } else {
            if (this.fom.realNameCard == undefined) {
              this.copysec();
            }
          }
        }

        if (this.fom.seriesModel.realNameType == 2) {
          window.location.href = `https://ec.iot.10086.cn/authApi/service/wx/realnameH5/stepOne?channelId=RNFORWEB&iccid=${this.details.iccId}&msisdn=${this.details.realNameCard}`;
        } else if (this.fom.seriesModel.realNameType == 1) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 3) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 4) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });
          realAddress(this.fom.meCardNum)
            .then((res) => {
              if (res.status == true) {
                console.log(res);
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
              this.offAlerts = true;
            });
        } else if (this.fom.realNameType == 5) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          getThirdPartyUrl(this.fom.meCardNum)
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
              this.offAlerts = true;
            });
        } else {
          var str = this.realurl.replace(/卡号/g, this.fom.iccId);
          window.location.href = str;
        }
      },
      onClick() {
        console.log("ahsgdhaj", this.biaoshi);
      },
      kefu() {
        window.location.href = this.kefuurl;
      },
      problem() {
        this.$router.push(`/problem`);
      },
      order() {
        this.$router.push(`/order`);
      },
      onCancel() {
        localStorage.removeItem("obj1");
      },
      //切换运营商
      edit() {
        this.fom.falseOpMap.forEach((item) => {
          if (item.name == this.radio && item.value == 0) {
            updateFalseOp(this.radio,item.meCardNum).then((res) => {
              if (res.status) {
                console.log(res);
                this.phoneSimCard();

                this.show = false;
                this.$dialog
                  .confirm({
                    message:
                      "切换运营商需要耐心等待2-5分钟,切换运营商完成后，建议重启设备",
                  })
                  .then(() => {
                    // on confirm
                  })
                  .catch(() => {
                    // on cancel
                  });
              }
            });
          } else if (item.name == this.radio && item.value !== 0) {
            this.$dialog
              .confirm({
                message: "当前运营商尚未实名，请先实名后在切换",
              })
              .then(() => {
                phoneSimCarda(item.meCardNum).then((res) => {
                  if (res.status) {
                    this.fom = res.data;
                    if (res.data.officialRealName != 0) {
                      if (res.data.seriesModel.realNameJudge == 0) {
                        this.offAlerts = true;
                      } else if (res.data.seriesModel.realNameJudge == 1) {
                        this.offAlerts = true;
                      } else if (
                        res.data.seriesModel.realNameJudge == 2 &&
                        res.data.isPay == true
                      ) {
                        this.offAlerts = true;
                      } else if (
                        res.data.seriesModel.realNameJudge == 3 &&
                        res.data.isPay == true &&
                        res.data.isTheMonth == true
                      ) {
                        this.offAlerts = true;
                      }
                    }
                  }
                });
              })
              .catch(() => {
                // on cancel
              });
          }
        });
      },
      balanceFn() {
        this.$router.push(`/problem`);
      },
      routers(val) {
        if (val.balancePayment == 1 && details.balance < val.couponEndPrice) {
          this.banlancesaaa = true;
        } else {
          val.a = 1;
          this.banlances = val;
          localStorage.removeItem("obj1");
          localStorage.setItem("obj1", JSON.stringify(val));
          this.shows = true;
        }
      },
      //获取地址
      url() {
        clientGet().then((res) => {
          if (res.status) {
            if (res.data) {
              this.kefuurl = res.data.customerService;
              this.realurl = res.data.realName;
              this.officialAccount = res.data.officialAccount;
            }
          }
        });
      },
      //刷新卡板
      refresh() {
        const refreshs = this.$toast.loading({
          message: "更新流量中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        refreshPhone()
          .then((res) => {
            if (res.status) {
              refreshs.clear();
              this.phoneSimCard();

              this.$toast(res.msg);
            }
          })
          .catch(() => {});
      },
      //获取后台设置
      ssse() {
        getAll().then((res) => {
          if (res.status) {
            console.log(res);
            document.title = res.data.weChatWebName;
            if (res.data.tel) {
              this.tel = "tel:" + res.data.tel;
              this.tel1 = res.data.tel;
              this.switchs = res.data.seriesTelSwitch;
            }
            if (res.data.workTime) {
              this.zuo = res.data.workTime;
            }

            if (this.$route.query.biaoShi == 1) {
              this.banlances = JSON.parse(localStorage.getItem("obj1"));
              this.shows = true;
            } else if (this.$route.query.biaoShi == 2) {
              phoneGetMeal().then((res) => {
                if (res.status) {
                  if (res.data.introduce == "") {
                    res.data.arr = [];
                  } else {
                    res.data.arr = res.data.introduce.split(/\n/g);
                  }
                  res.data.a = 2;

                  if (res.data.validity == 30 && res.data.validityType == 0) {
                    this.detail = res.data;
                    this.detail.next = "";
                    this.detail.nexts = false;
                    console.log("1", this.detail.next);
                  } else if (res.data.next == false) {
                    this.detail = res.data;
                    this.detail.next = "";
                    this.detail.nexts = res.data.next;
                    console.log("2", this.detail.next);
                  } else {
                    this.detail = res.data;
                    this.detail.next = "";
                    this.detail.nexts = res.data.next;

                    console.log("3", this.detail.next);
                  }
                  console.log("aa", this.detail);
                  if (
                    localStorage.getItem("next") != null &&
                    localStorage.getItem("next") != undefined &&
                    localStorage.getItem("next") != ""
                  ) {
                    if (localStorage.getItem("next") == "false") {
                      this.detail.next = "";
                    } else {
                      this.detail.next = "";
                    }
                    // alert(localStorage.getItem("next"));
                  }
                  // this.changess();
                }
              });
            }
          }
        });
      },
      router(s) {
        this.payShopCheck == "";
        this.payShopChecks == "";
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        // if (s.balancePayment == 1 && this.details.balance < s.couponEndPrice) {
        //   this.banlancesaaa = true;
        // } else {
        phoneGetMeals(s.id).then((res) => {
          if (res.status) {
            res.data.isRead = true;
            if (res.data.seriesModel.speedMembershipList){
              if (res.data.seriesModel.speedMembershipList.length > 0) {
              res.data.speedShow = true;
              res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
             } else {
              res.data.speedShow = false;
             }
            }else {
              res.data.speedShow = false;
            }
            
            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 2;
            res.data.cardBalance = this.fom.balance;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;
              this.detail.balancePayments=s.balancePayment
              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.balancePayments=s.balancePayment
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            localStorage.removeItem("balanceshow");
            // this.changess();
            if (this.detail.seriesModel.prestore == true) {
              if (this.details.balance < s.couponEndPrice) {
                this.$dialog
                  .confirm({
                    message:
                      "账户余额小于要支付的套餐金额点击确认跳转余额充值界面",
                  })
                  .then(() => {
                    this.$router.push(`/recharge`);
                  })
                  .catch(() => {
                    // on cancel
                  });
              } else {
                this.show = true;
              }
            } else {
              if (this.detail.planAlert == true) {
                this.planAlert = this.detail.planAlert;
              } else {
                this.show = true;
              }
            }
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
        // }
      },

      phoneMeal() {
        this.cc = [];
        getCategorySetMeal().then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              if (item.setMealModels.length > 0) {
                this.cc.push(item);
              }
              item.setMealModels.forEach((items) => {
                console.log(items.id, document.getElementById(items.id));
              });
            });
          }
        });
      },
      banlance() {
        this.$router.push(`/recharge`);
      },
      //获取卡详情
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.listS = [];
            if (res.data.ordersModel) {
              if (res.data.ordersModel.operatorSwitch) {
                res.data.ordersModel.operatorSwitch = JSON.parse(
                  res.data.ordersModel.operatorSwitch
                );
                res.data.ordersModel.operatorSwitch.forEach((item) => {
                  this.three.forEach((items) => {
                    if (items.id == item) {
                      this.listS.push(items);
                    }
                  });
                });
              } else {
                this.listS = this.three;
              }
            } else {
              if (res.data.seriesModel.operatorSwitch) {
                res.data.seriesModel.operatorSwitch = JSON.parse(
                  res.data.seriesModel.operatorSwitch
                );
                res.data.seriesModel.operatorSwitch.forEach((item) => {
                  this.three.forEach((items) => {
                    if (items.id == item) {
                      this.listS.push(items);
                    }
                  });
                });
              } else {
                this.listS = this.three;
              }
            }
            this.details = res.data;
            this.fom = res.data;
            this.radio = res.data.falseOp;
            this.title = "卡号：" + localStorage.getItem("meCardNum");
            Loading.service().close();
            if (res.data.isChange == 1) {
              this.$dialog
                .confirm({
                  message: `${res.data.alert}`,
                  confirmButtonText: "申请换卡",
                  cancelButtonText: "查询进度",
                  closeOnClickOverlay: false,
                })
                .then(() => {
                  this.$router.push({
                    name: "Address",
                    query: {
                      type: res.data.postAge,
                      id: res.data.logoutClassifyTypeModel.id,
                    },
                  });
                })
                .catch(() => {
                  this.$router.push(`/success`);
                });
            } else {
              if (res.data.officialRealName != 0) {
                console.log(res.data, "看看官方实名");
                if (res.data.seriesModel.realNameJudge == 0) {
                  console.log(res.data, "看看官方实名1");
                  this.offAlerts = true;
                } else if (res.data.seriesModel.realNameJudge == 1) {
                  console.log(res.data, "看看官方实名2");
                  this.offAlerts = true;
                } else if (
                  res.data.seriesModel.realNameJudge == 2 &&
                  res.data.isPay == true
                ) {
                  console.log(res.data, "看看官方实名3");
                  this.offAlerts = true;
                } else if (
                  res.data.seriesModel.realNameJudge == 3 &&
                  res.data.isPay == true &&
                  res.data.isTheMonth == true
                ) {
                  console.log(res.data, "看看官方实名4");
                  this.offAlerts = true;
                } else {
                  console.log(res.data, "看看官方实名5");
                }
              } else {
                if (
                  this.details.endRemind == true &&
                  localStorage.getItem("end") == null
                ) {
                  this.$dialog
                    .alert({
                      message:
                        "检测到您的流量即将到期，请及时续费，否则将影响您的正常使用",
                    })
                    .then(() => {
                      localStorage.setItem("end", 1);
                      if (this.details.seriesCouponModel) {
                        this.Alerts = true;
                      }
                    });
                } else if (res.data.seriesCouponModel) {
                  this.Alerts = true;
                }
              }
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss">
  .titleas111111111111 {
    max-height: 360px;
    overflow: auto;
    margin: 10px 10px;
    text-align: left;
    p {
      img {
        width: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
.vipBoxNew{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  // background: #f5f5f5;
  box-sizing: border-box;
  border-radius: 10px;
  // margin: 15px 0;
  // padding: 15px;
  .vipBoxNew-item{
    width: 100%;
    position: relative;
    .imageBoxNew {
      width: 100%;
      height: 160px;
      border-radius: 5px;
    }

    .yBoxNew {
      width: 74px;
      height: 31px;
      background-color: #ffcc6b;
      color: #fff;
      font-size: 13px;
      text-align: center;
      line-height: 31px;
      border-radius: 5px 0px 5px 0px;
      position: absolute;
      bottom: 2px;
      right: 0px;
    }
  }
}
  .content-radio {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(#009fff, 0.2);
    border-bottom: 1px solid #1890ff;
  }
  .imgs {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }

  .display-left {
    width: 50%;
    text-align: left;
    align-items: center;
    justify-self: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .display-right {
    display: flex;
    align-items: center;
    width: 45%;
    justify-content: flex-end;
    margin-right: 5%;
  }
  .top {
    box-sizing: border-box;
    height: 65px;
    padding: 12px;
    background: #07c160;
  }

  .top-one {
    display: flex;
    justify-content: space-between;
    background: #07c160;
  }

  .real {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding: 5px;
    background: #fff;
  }
  .middle {
    margin-top: 10px;
    background: #fff;
  }

  .order {
    width: 100%;
    font-size: 14px;

    line-height: 14px;
    color: #07c160;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .tuijian {
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: #ff0066;
    height: 15px;
    text-align: center;
    border-radius: 5px 0 6px 0;
    color: white;
  }

  .ee {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 10px;
  }

  .tuijian {
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: #ff0066;
    height: 15px;
    text-align: center;
    border-radius: 5px 0 6px 0;
    color: white;
    padding: 0 5px;
  }
  .bottom {
    height: 70vh;
    margin-top: 20px;
    padding-bottom: 300px;
    background-color: #efeff4;
    width: 100%;
    height: 15px;
    line-height: 15px;
    text-align: center;
    color: white;
  }
  .contenta {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border: 1px solid #1890ff;
    border-bottom: 0;
    border-left: 0;
    border-right: 0;
    display: flex;
  }
  .content {
    width: 100%;
    background-color: white;
    padding: 20px;
    color: black;
    font-weight: 600;
    font-size: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #1890ff;
    display: flex;
  }

  .contents {
    width: 100%;
    background-color: white;
    padding: 10px;
    box-sizing: border-box;
  }
  .hiddens {
    color: #07c160;
    width: 160px;
  }
  .hidden {
    width: 160px;
  }

  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .img {
    width: 35px;
    height: 35px;
  }

  .text {
    width: 90%;
    margin-left: 5px;

    color: #fff;
  }

  .line {
    line-height: 17px;
    width: 150px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .linea {
    line-height: 17px;
    text-align: left;
  }
  .num {
    font-weight: 900;
    font-size: 14px;
    color: #07c160;
    margin-bottom: 3px;
  }
  .ref {
    width: 35px;
    height: 35px;
    color: #07c160;
    background: #fff;
    border-radius: 50%;
  }
  .box {
    position: relative;
    width: 48%;
    /* height: 70px; */
    box-sizing: border-box;
    padding: 15px 5px;
    /* margin-top: 10px; */
    margin-bottom: 10px;
    border: 1px solid #07c160;
    border-radius: 7px;
  }
  .boxs {
    width: 48%;
    /* height: 70px; */
    box-sizing: border-box;
    padding: 10px;

    margin-bottom: 10px;
    border: 1px solid transparent;
    border-radius: 7px;
  }
  .active {
    color: #ffd700;
  }
</style>
